// useUpdateOrderStatusMutation.js
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { deleteCommentFromRepairOrder } from "api/repair-orders";

const useDeleteComment = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(deleteCommentFromRepairOrder, {
    onMutate: async ({ repairOrderId, commentId }) => {
      // Cancel any outgoing refetches
      await queryClient.cancelQueries({
        queryKey: ["repairOrder", repairOrderId],
      });

      // Snapshot the previous data
      const previousOrder = queryClient.getQueryData([
        "repairOrder",
        repairOrderId,
      ]);

      if (!previousOrder) {
        console.error("No previous order found");
        console.log("repairOrderId", repairOrderId);
        return;
      }

      //Remove the service from the services array
      queryClient.setQueryData(["repairOrder", repairOrderId], (old) => ({
        ...old,
        updatedAt: dayjs().toISOString(),
        comments: old.comments.filter((comment) => comment.id !== commentId),
      }));

      // Return context with the previous order for rollback
      return { previousOrder };
    },
    onError: (error, variables, context) => {
      if (context?.previousOrder) {
        queryClient.setQueryData(
          ["repairOrder", variables.repairOrderId],
          context.previousOrder
        );
      }
      console.log(error.response);
      console.error(error?.response?.data?.message || "Error deleting comment");
      if (error?.response?.data?.message) {
        enqueueSnackbar(error?.response?.data?.message, { variant: "error" });
      } else {
        enqueueSnackbar("Error deleting comment", { variant: "error" });
      }
    },
    onSuccess: (data, variables) => {
      enqueueSnackbar("Comment delete successfully", { variant: "success" });
    },
  });
};

export default useDeleteComment;
